// extracted by mini-css-extract-plugin
export default {"story":"Story_story__PqOGO","story_desc":"Story_story_desc__r53NP"};